export function workoutSlider() {
    const isTouch = this.isTouch;

    $(".workout-slider").each(function () {
        const sliderWrapItem = $(this);
        const sliderContent = sliderWrapItem.find(".workout-slider-content");
        const sliderPicture = sliderWrapItem.find(".workout-slider-picture");
        const sliderControls = sliderWrapItem.find(".slider-controls");

        sliderContent
            // .on('init', function (event, slick) {
            //     $(sliderPicture).find('.slide').eq(0).addClass('currentSlider');
            // })
            .slick({
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 1,
                // slidesToShow: 2.4,
                variableWidth: true,
                dots: false,
                arrows: true,
                focusOnSelect: true,
                speed: 200,
                appendArrows: sliderControls,
                asNavFor: '.workout-slider-picture',
                prevArrow:'<button class="slick-prev"><svg  viewBox="0 0 18 16"><path d="M8 1L1 8M1 8L8 15M1 8L17 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                nextArrow:'<button class="slick-next"><svg viewBox="0 0 18 16"><path d="M10 1L17 8M17 8L10 15M17 8L1 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            variableWidth: false,
                            focusOnSelect: false
                        }
                    }
                ]
            })
            .on('setPosition', function (event, slick) {

                slick.$slides.find('.workout-slide').css('height', slick.$slideTrack.height() + 'px');

            })
            .on("beforeChange", function (event, slick, currentSlide, nextSlide) {

                if (currentSlide !== nextSlide) {
                    $(sliderContent).find('.text').addClass('animation');
                    $(sliderControls).addClass('disabled');
                }

            })
            .on("afterChange", function (event, slick, currentSlide, nextSlide) {

                currentSlide += 1;
                let value = currentSlide < 10 ? '0' + currentSlide : currentSlide;
                $(".cur-slide").text(value);

                setTimeout(() => {
                    $(sliderContent).find('.text').not(".slick-current .text").removeClass('animation');
                }, 200);

                setTimeout(() => {
                    $(sliderContent).find('.slick-current .text').removeClass('animation');
                    $(sliderControls).removeClass('disabled');
                }, 550);

            });

        sliderPicture.slick({
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            variableWidth: true,
            // rtl: true,
            dots: false,
            arrows: false,
            // fade: true,
            asNavFor: '.workout-slider-content',
            speed: 1000,
            cssEase: 'cubic-bezier(0.000, 0.000, 0.000, 1.005)'
        });

        const slidesAmount = sliderContent.find(".slick-slide").length;
        const slideCounterTemplate = `<span class="counter-sliders"><strong class="cur-slide">01</strong><span class="divider"></span><strong>${slidesAmount < 10 ? '0' + slidesAmount : slidesAmount}</strong></span>`;

        $(slideCounterTemplate).insertAfter(sliderControls.find(".slick-prev"));

    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/workout-slider.js